import { isAndroid, isIOS } from 'react-device-detect'

export default () => {
  if (isAndroid) return 'android'
  if (isIOS) return 'ios'
  return 'unknown'
}
